import axiosCall from './interceptor';
import URL from '../helper';

export const organisation = async () => {
  const url = `${URL.BASE_URL}organization`;
  let response = await axiosCall('get', url);
  return response.data;
};

export const CreateOrganisation = async data => {
  const url = `${URL.BASE_URL}organization`;
  let response = await axiosCall('post', url, data, false);
  return response.data;
};

export const licenseDetails = async () => {
  const url = `${URL.BASE_URL}organization/licensedetails`;
  let response = await axiosCall('get', url);
  return response.data;
}

export const getClientOrganisationDetails = async () => {
  const url = `${URL.BASE_URL}client/organization`;
  let response = await axiosCall('get', url);
  return response.data;
};
